<template>
  <div>
    <div class="pageSatatus">
      <iframe
        :src="iframeSrc"
        frameborder="0"
        ref="iframeRef"
        allow="clipboard-write"
        @load="onIframeLoad"     
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    smartAdjustDomain() {
      const env = process.env.VUE_APP_REAL_ENV || process.env.VUE_APP_API_ENV;
      let domainUrl = '';
      if (env === 'development' || env === 'develop') {
        domainUrl = 'http://localhost:5173';
      } else if (env === 'test') {
        domainUrl = 'https://adstest.giikin.com';
      } else if (env === 'msestage') {
        domainUrl = 'https://manage-test.giikin.cn/fe/ad/integrated';
      } else if (env === 'mseprod') {
        domainUrl = 'https://manage.giikin.com/fe/ad/integrated';
      } else {
        domainUrl = 'https://gk-ads.giikin.com';
      }
      return domainUrl;
    },
    iframePath() {
      const routeName = this.$route.name;
      if (routeName === 'smartAdjust') return '/smartAdjust?embed=1';
      if (routeName === 'adTools') return '/smart-ad-operations/ad-tools?embed=1';
      if (routeName === 'autoRuleManage') return '/smart-ad-operations/autorule?embed=1';
      return '/intelligentRecommend';
    },
    iframeSrc() {
      return `${this.smartAdjustDomain}${this.iframePath}`;
    },
  },
  methods: {
    onIframeLoad() {
      const saToken = localStorage.getItem('saToken');
      const postParams = {
        saToken: saToken,
        type: 'fromTtAssiant',
      };
      this.$refs.iframeRef.contentWindow.postMessage(postParams, this.smartAdjustDomain);
    },
  },
};
</script>

<style lang="scss" scoped>
.pageSatatus {
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: calc(100vh - 90px);
  }
}
</style>
